import React, { Fragment, useState } from "react";
import { DotsThreeIcon, PencilIcon, TrashIcon } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import ConversationRenamePopup from "components/Conversations/ConversationRenamePopup";
import ConversationDeletePopup from "components/Conversations/ConversationDeletePopup";

export default function SidebarConversationItem({
    conversation
}) {

    const [openDropdown, setOpenDropdown] = useState(false);
    const [renamePopup, setRenamePopup] = useState(false);
    const [deletePopup, setDeletePopup] = useState(false);

    const { _id, name, agent } = conversation;

    let urlTo = `/conversations/${_id}`;
    if (agent) {
        urlTo = `/agents/${agent.slug}/${agent._id}/conversations/${_id}`;
    }

    const renamePopupHandler = () => {
        setOpenDropdown(false);
        setRenamePopup(true);
    }

    const deletePopupHandler = () => {
        setOpenDropdown(false);
        setDeletePopup(true);
    }

    return (
        <Fragment>
            <div
                className="group flex gap-2 items-center w-full p-2 hover:bg-light/30 rounded-sm"
                onMouseLeave={() => setOpenDropdown(false)}
                onBlur={(e) => { if (!e.currentTarget.contains(e.relatedTarget)) setOpenDropdown(false); }}
            >
                <Link to={urlTo} className="flex-1 truncate">
                    {name}
                </Link>
                <div className="relative opacity-0 group-hover:opacity-100 group-focus-within:opacity-100">
                    <button
                        type="button"
                        aria-label="Opzioni conversazione"
                        aria-haspopup="menu"
                        aria-expanded={openDropdown}
                        onClick={() => setOpenDropdown(o => !o)}
                        className="touch-target flex items-center justify-center p-1 rounded cursor-pointer hover:bg-black/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow"
                    >
                        <DotsThreeIcon size={20} className="fill-black" weight="bold" />
                    </button>

                    <div role="menu" className="absolute right-0 top-7 rounded-lg shadow-lg w-48 z-[var(--z-dropdown)] bg-white overflow-hidden" style={{ display: openDropdown ? 'block' : 'none' }}>
                        <button type="button" role="menuitem" onClick={renamePopupHandler} className="w-full text-left flex items-center gap-2 p-3 hover:bg-verylight focus:outline-none focus-visible:bg-verylight">
                            <PencilIcon size={16} className="fill-black" />
                            Rinomina conversazione
                        </button>
                        <button type="button" role="menuitem" onClick={deletePopupHandler} className="w-full text-left flex items-center gap-2 p-3 hover:bg-verylight focus:outline-none focus-visible:bg-verylight">
                            <TrashIcon size={16} className="fill-black" />
                            Elimina conversazione
                        </button>
                    </div>
                </div>
            </div>

            <ConversationRenamePopup
                visible={renamePopup}
                setVisible={setRenamePopup}
                conversation={conversation}
            />

            <ConversationDeletePopup
                visible={deletePopup}
                setVisible={setDeletePopup}
                conversation={conversation}
            />
        </Fragment>
    )
}
